import type {
  IOnboardingInitiateSubmitterVerificationBody,
  IOnboardingInitiateSubmitterVerificationRequest,
  IOnboardingInitiateSubmitterVerificationResponse,
} from '@/app-package';

import axios from 'axios';

const initiateSubmitterVerification = async (
  body: IOnboardingInitiateSubmitterVerificationBody,
  orgClaimHash: string,
) => {
  const url = `/onboarding/verify/org_submitter/${orgClaimHash}`;

  const config: IOnboardingInitiateSubmitterVerificationRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingInitiateSubmitterVerificationResponse>(
      config,
    );

  return data;
};

export default initiateSubmitterVerification;
